<section class="container-fluid backgroundColor shark darken-3 position-relative top-119" id="my-element">
  <div class="row">
    <div class="col-md-6 text-white no-padd img-mobile-view">
      <img src="../../assets/images/contact/penhaStore.jpg" class="img-fluid img-penhalonga" alt="" srcset="">
    </div>
    <div class="col-md-6 text-center no-padd text-mobile-view">
      <ul class="list-group list-group-flush mt-12">
        <li class="list-group-item textColor new-orleans base border-0">
        </li> <br><br>
        <li class="list-group-item textColor new-orleans base border-0">
          <h1>Loja no Hotel Penha Longa</h1>
        </li>
        <li class="list-group-item border-0 text-white"><a href="https://www.google.pt/maps/place/Penha+Longa+Resort/@38.7615719,-9.3975618,216m/data=!3m1!1e3!4m8!3m7!1s0xd19335dce4e0e7d:0x2a9fff2baf77fd53!5m2!4m1!1i2!8m2!3d38.7615079!4d-9.3970096" target="blank" class="font-decoration text-white">Estrada da Lagoa Azul <br> Penha Longa Hotel e Golf Resort <br> 2714-511 Sintra</a></li>
        <li class="list-group-item border-0"><a class="font-decoration text-white" href="tel:00351219244223">(+351) 219 244 223</a></li>
        <li class="list-group-item border-0"><a class="font-decoration text-white" href="tel:00351219105580">(+351) 219 105 580</a></li>
        <li class="list-group-item border-0"><a class="font-decoration text-white" href="mailto:penhalonga@relojoaria.pt">penhalonga&#64;relojoariafaria.pt</a></li>
        <li class="list-group-item border-0"><a class="font-decoration text-white" href="mailto:info@relojoariafaria.pt">info&#64;relojoariafaria.pt</a></li>
        <li class="list-group-item border-0 pb-5"><a href="https://www.google.pt/maps/place/Penha+Longa+Resort/@38.7615719,-9.3975618,216m/data=!3m1!1e3!4m8!3m7!1s0xd19335dce4e0e7d:0x2a9fff2baf77fd53!5m2!4m1!1i2!8m2!3d38.7615079!4d-9.3970096" target="blank" class="font-decoration text-white">38.7615719,-9.3975618</a></li>
      </ul>
    </div>
  </div>
</section>
<section class="container-fluid bg-gradient-reverse position-relative top-119 nav-border-bottom">
  <div class="row">
    <div class="col-md-6 text-center no-padd text-mobile-view-2">
      <ul class="list-group list-group-flush mt-16">
        <li class="list-group-item textColor new-orleans base border-0">
          <br><br>
        </li>
        <li class="list-group-item  textColor new-orleans base border-0">
          <h1>Loja de Sintra</h1>
        </li>
        <li class="list-group-item border-0"><a class="font-decoration text-white" href="https://www.google.pt/maps/place/Relojoaria+Faria,+Lda/@38.8013983,-9.3829678,3a,75y,72.62h,72.27t/data=!3m6!1e1!3m4!1s8_pBRUcJ1ojR4knTsconZA!2e0!7i16384!8i8192!4m5!3m4!1s0xd1eda969469c077:0x403060f8ba4fe5b0!8m2!3d38.8014348!4d-9.3828048" target="blank" rel="noopener noreferrer">Largo Afonso de Albuquerque, nº7 <br> 2710-519 Sintra</a></li>
        <li class="list-group-item border-0"><a class="font-decoration text-white" href="tel:00351219105580">(+351) 219 105 580</a></li>
        <li class="list-group-item border-0"><a class="font-decoration text-white" href="tel:00351219244223">(+351) 219 244 223</a></li>
        <li class="list-group-item border-0"><a class="font-decoration text-white" href="mailto:info@relojoariafaria.pt">info&#64;relojoariafaria.pt</a></li>
        <li class="list-group-item border-0"><a class="font-decoration text-white" href="mailto:penhalonga@relojoaria.pt">penhalonga&#64;relojoariafaria.pt</a></li>
        <li class="list-group-item border-0"><a class="font-decoration text-white" href="https://www.google.pt/maps/place/Relojoaria+Faria,+Lda/@38.8013983,-9.3829678,3a,75y,72.62h,72.27t/data=!3m6!1e1!3m4!1s8_pBRUcJ1ojR4knTsconZA!2e0!7i16384!8i8192!4m5!3m4!1s0xd1eda969469c077:0x403060f8ba4fe5b0!8m2!3d38.8014348!4d-9.3828048" target="blank" rel="noopener noreferrer">38.8013983,-9.3829678</a></li>
      </ul>
    </div>
    <div class="col-md-6 text-white no-padd img-mobile-view-2">
      <img src="../../assets/images/contact/sintraStore.jpg" class="img-fluid" alt="" srcset="">
    </div>
  </div>
</section>
<div class="backgroundColor mine-shaft base">
  <section class="container-fluid  backgroundColor mine-shaft base position-relative -top-142 pb-5" id="messageUs">
    <div class="container">
      <section class="mb-4">
        <!--Section heading-->
        <h2 class="text-center pt-4 my-4"><fa-icon [icon]="faCommentAlt" class="fad fa-comments-alt fa-2x textColor harvest-gold base"></fa-icon></h2>
        <!--Section description-->
        <p class="text-center mx-auto text-white mb-5">Para mais informações não hesite em nos contactar</p>
      </section>
      <form>
        <div class="row">
          <div class="col-12 col-lg-6 py-2">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"><fa-icon [icon]="faUserTie" class="fad fa-user-tie textColor mine-shaft base"></fa-icon></span>
              </div>
              <input type="text" class="form-control" placeholder="Nome Completo" aria-label="Username" aria-describedby="basic-addon1">
            </div>
          </div>
          <div class="col-12 col-lg-6 py-2">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"><fa-icon [icon]="faPhoneAlt" class="fad fa-phone-alt textColor mine-shaft base"></fa-icon></span>
              </div>
              <input type="text" class="form-control" placeholder="Telefone" aria-label="Phone" aria-describedby="basic-addon1">
            </div>
          </div>
          <div class="col-12 col-lg-6 py-2">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"><fa-icon [icon]="faAt" class="fad fa-at textColor mine-shaft base"></fa-icon></span>
              </div>
              <input type="email" class="form-control" placeholder="E-mail" aria-label="Username" aria-describedby="basic-addon1">
            </div>
          </div>
          <div class="col-12 col-lg-6 py-2">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"><fa-icon [icon]="faMicrophone" class="fad fa-megaphone textColor mine-shaft base"></fa-icon></span>
              </div>
              <input type="text" class="form-control" placeholder="Assunto" aria-label="Phone" aria-describedby="basic-addon1">
            </div>
          </div>
          <div class="col-12 col-lg-12 py-2">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"><fa-icon [icon]="faCommentAlt" class="fad fa-comment-alt-dots"></fa-icon></span>
              </div>
              <textarea class="form-control" aria-label="With textarea" cols="30" rows="8"></textarea>
            </div>
            <div class="card-group">
              <div class="card">
                <div class="card-footer">
                  <small class="text-muted">Por favor seja breve a Relojoaria / Joalharia Faria agradece</small>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end pt-5">
              <button class="btn btn-grad px-4 py-2 duration-500">Enviar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</div>